import React from 'react';
// import './ForumInput.scss'

const FormInput = ({width = "auto", title, name, onChange, type = "text", defaultValue, value, desc, placeholder, values=[], ...props}) =>
    <div className="form-inline" style={{ width: width}}>

        {(type === "textarea") && 
            <textarea
                name={name || (title && title.toLowerCase()) || ""}
                type={type}
                className="input"
                onChange={onChange}
                placeholder={placeholder}
                defaultValue={defaultValue}
                value={value} />}
        {(type === "text") &&
            <input
                name={name || (title && title.toLowerCase()) || ""}
                type={type}
                className="input"
                onChange={onChange}
                placeholder={placeholder}
                defaultValue={defaultValue}
                value={value} />}
        {(type === "password") &&
            <input
                name={name || (title && title.toLowerCase()) || ""}
                type={type}
                className="input"
                onChange={onChange}
                autoComplete={"off"}
                placeholder={placeholder}
                defaultValue={defaultValue}
                value={value} />}
        {(type === "select") &&
            <select
                name={name || (title && title.toLowerCase()) || ""}
                className="input"
                onChange={onChange}
                placeholder={placeholder}
                defaultValue={defaultValue}
                value={value}>
                {values.map((val, i) =>
                    <option key={i} value={val}>{`${val}`}</option>)}
            </select>}
</div>

export default FormInput;


// WEBPACK FOOTER //
// ./src/Components/FormInput.js